import { TranslationKey } from './en';

export const de = {
  'nav.dashboard': 'Übersicht',
  'nav.fields': 'Felder',
  'nav.planning': 'Planung',
  'nav.calendar': 'Kalender',
  'nav.statistics': 'Statistik',

  'shell.farmOverview': 'Hofübersicht',
  'shell.goodMorning': 'Guten Morgen',
  'shell.synced': 'Synchronisiert',
  'shell.syncError': 'Nicht synchronisiert',
  'shell.syncError.title': 'Synchronisierung nicht möglich',
  'shell.syncError.httpStatus': 'HTTP-Status',
  'shell.syncError.unreachable':
    'Der Server ist nicht erreichbar. Prüfe, ob dein Dedicated Server läuft und im Netzwerk erreichbar ist.',
  'shell.syncError.auth':
    'Der Server hat die Anfrage abgelehnt. Möglicherweise ist deine Sitzung abgelaufen – lade die Seite neu.',
  'shell.syncError.notFound':
    'Der Server hat geantwortet, aber die erwarteten Daten wurden nicht gefunden. Die API ist evtl. falsch konfiguriert oder veraltet.',
  'shell.syncError.server':
    'Der Server hat mit einem internen Fehler geantwortet. Er startet evtl. noch oder ist überlastet – versuch es gleich noch einmal.',
  'shell.syncError.generic':
    'Der Server hat unerwartet geantwortet, daher konnten die Daten nicht synchronisiert werden.',
  'shell.gameServer': 'Spielserver',
  'shell.connected': 'Verbunden',

  'dashboard.overview': 'Übersicht',
  'dashboard.title': 'Dein Hof auf einen Blick',
  'dashboard.subtitle': 'Feldstatus, anstehende Arbeiten und Serveraktivität.',
  'dashboard.newPlanning': 'Neue Feldplanung',

  'dashboard.farmStatus': 'Hofstatus',
  'dashboard.runningSmoothly': 'Alles läuft wie geplant.',
  'dashboard.serverUpToDate':
    'Dein Spielserver ist verbunden und die Felddaten sind aktuell.',
  'dashboard.serverConnected': 'Server verbunden',
  'dashboard.lastSync': 'Gerade synchronisiert',

  'dashboard.fields': 'Felder',
  'dashboard.totalFields': 'Felder insgesamt',
  'dashboard.totalArea': 'Gesamtfläche',
  'dashboard.managedFarmland': 'Bewirtschaftete Fläche',
  'dashboard.openTasks': 'Offene Aufgaben',
  'dashboard.planningItems': 'Geplante Arbeiten',
  'dashboard.nextHarvest': 'Nächste Ernte',

  'dashboard.currentFieldStatus': 'Aktueller Feldstatus',
  'dashboard.viewAll': 'Alle anzeigen',
  'dashboard.loadingFields': 'Felder werden geladen...',
  'dashboard.noFields': 'Noch keine Felder angelegt',
  'dashboard.noFieldsHint':
    'Lege dein erstes Feld an, um den Status hier zu verfolgen.',
  'dashboard.addField': 'Feld anlegen',

  'dashboard.nextUp': 'Als Nächstes',
  'dashboard.plannedWork': 'Geplante Arbeiten',

  'dashboard.liveSync': 'Live-Sync',
  'dashboard.dedicatedServerConnected': 'Dedicated Server verbunden',

  'gameState.day': 'Tag',
  'gameState.clock': 'Uhr',

  'gameState.month.january': 'Januar',
  'gameState.month.february': 'Februar',
  'gameState.month.march': 'März',
  'gameState.month.april': 'April',
  'gameState.month.may': 'Mai',
  'gameState.month.june': 'Juni',
  'gameState.month.july': 'Juli',
  'gameState.month.august': 'August',
  'gameState.month.september': 'September',
  'gameState.month.october': 'Oktober',
  'gameState.month.november': 'November',
  'gameState.month.december': 'Dezember',
  'gameState.month.unknown': 'Monat',

  'field.field': 'Feld',
  'field.planned': 'geplant',

  'field.growthStatus.growing': 'Wachsend',
  'field.growthStatus.harvestable': 'Erntereif',
  'field.growthStatus.cut': 'Geschnitten',
  'field.growthStatus.unknown': 'Unbekannt',

  'crop.none': 'Keine Frucht',
  'crop.wheat': 'Weizen',
  'crop.barley': 'Gerste',
  'crop.canola': 'Raps',
  'crop.oat': 'Hafer',
  'crop.maize': 'Mais',
  'crop.sunflower': 'Sonnenblumen',
  'crop.soybean': 'Sojabohnen',
  'crop.potato': 'Kartoffeln',
  'crop.rice': 'Reis',
  'crop.rice_long_grain': 'Langkornreis',
  'crop.sugar_beet': 'Zuckerrüben',
  'crop.sugar_cane': 'Zuckerrohr',
  'crop.cotton': 'Baumwolle',
  'crop.sorghum': 'Sorghumhirse',
  'crop.grape': 'Weintrauben',
  'crop.olive': 'Oliven',
  'crop.poplar': 'Pappeln',
  'crop.beetroot': 'Rote Bete',
  'crop.carrot': 'Karotten',
  'crop.parsnip': 'Pastinaken',
  'crop.green_bean': 'Grüne Bohnen',
  'crop.pea': 'Erbsen',
  'crop.spinach': 'Spinat',
  'crop.grass': 'Gras',
  'crop.oilseed_radish': 'Ölrettich',
  'crop.rye': 'Roggen',
  'crop.millet': 'Hirse',
  'crop.poppy': 'Mohn',
  'crop.spelt': 'Dinkel',
  'crop.hops': 'Hopfen',
  'crop.lavender': 'Lavendel',
  'crop.alfalfa': 'Luzerne',
  'crop.clover': 'Klee',
  'crop.tobacco': 'Tabak',
  'crop.hemp': 'Hanf',
  'crop.red_cabbage': 'Rotkohl',
  'crop.white_cabbage': 'Weißkohl',
  'crop.meadow': 'Wiese',
  'crop.onion': 'Zwiebeln',

  'dashboard.noHarvestReady': 'Keine Ernte bereit',
  'dashboard.noHarvestReadyHint': 'Aktuell ist kein Feld erntereif.',
  'dashboard.loadFieldsError': 'Die Felder konnten nicht geladen werden.',

  'task.harvest': 'Ernten',
  'task.plow': 'Pflügen',
  'task.lime': 'Kalken',
  'task.cultivate': 'Grubbern',
  'task.sow': 'Säen',
  'task.fertilize': 'Düngen',
  'task.mulch': 'Mulchen',
  'task.roll': 'Walzen',
  'task.weed': 'Unkraut entfernen',
  'task.unknown': 'Aufgabe',
  'task.noOpenTasks': 'Keine offenen Aufgaben',

  'task.status.open': 'Offen',
  'task.status.planned': 'Geplant',
  'task.status.done': 'Erledigt',

  'task.form.title': 'Neue Feldplanung',
  'task.form.field': 'Feld',
  'task.form.selectField': 'Feld auswählen',
  'task.form.work': 'Arbeit',
  'task.form.plannedFor': 'Geplant für',
  'task.form.cancel': 'Abbrechen',
  'task.form.save': 'Planung speichern',

  'cropRotation.eyebrow': 'Anbauplanung',
  'cropRotation.title': 'Fruchtfolge',
  'cropRotation.subtitle':
    'Plane die Kulturen deiner Felder über mehrere Anbauperioden.',
  'cropRotation.field': 'Feld',
  'cropRotation.current': 'Aktuell',
  'cropRotation.planned': 'Geplant',
  'cropRotation.unfavorable': 'Ungünstig',
  'cropRotation.plan': 'Frucht planen',
  'cropRotation.loading': 'Fruchtfolge wird geladen...',
  'cropRotation.error': 'Die Fruchtfolge konnte nicht geladen werden.',

  'cropRotation.period.current': 'Aktuell',
  'cropRotation.period.next': 'Nächste',
  'cropRotation.period.afterNext': 'Danach',
  'cropRotation.period.later': 'Danach +{count}',

  'cropRotation.advice.title': 'Fruchtfolge-Empfehlung',
  'cropRotation.advice.loading': 'Empfehlungen werden geladen...',
  'cropRotation.advice.error': 'Die Empfehlungen konnten nicht geladen werden.',
  'cropRotation.advice.saveError':
    'Die Fruchtplanung konnte nicht gespeichert werden.',
  'cropRotation.advice.recommended': 'Empfohlen',
  'cropRotation.advice.possible': 'Möglich',
  'cropRotation.advice.warning': 'Warnung',

  'cropRotation.advice.reason.cropBreak':
    'Die empfohlene Anbaupause für diese Kultur ist noch nicht erreicht.',
  'cropRotation.advice.reason.repeatedCrop':
    'Diese Kultur wurde bereits in der vorherigen Periode angebaut.',
  'cropRotation.advice.reason.cerealAfterCereal':
    'Getreide nach Getreide ist möglich, aber nicht optimal für eine abwechslungsreiche Fruchtfolge.',
  'cropRotation.advice.reason.cropChange':
    'Der Kulturwechsel ist für die Fruchtfolge günstig.',
  'cropRotation.advice.reason.noHistory':
    'Für diese Fläche liegt noch keine vorherige Anbauperiode vor.',

  'planning.tasks': 'Aufgaben',
  'planning.cropRotation': 'Fruchtfolge',

  'language.de': 'Deutsch',
  'language.en': 'English',
  'language.change': 'Sprache ändern',
} satisfies Record<TranslationKey, string>;
